export default __webpack_public_path__ + "static/media/empty.0c977eb3.svg";